<div class="text-center">
  <h2>AS2 Communication Details</h2>
</div>

<div class="row p-5">
  <div class="col-sm-12 col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">AS2 Production</h4>
      </div>
      <div class="card-body">
        <form>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Identifier</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="MedShortsLLC"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">URL</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="http://b2bidev.medshorts.com:4080/exchange/MedShortsLLC"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Type</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="HTTP"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Encryption</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="TripleDES"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">MDN Receipt</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="Synchronous"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">ISA ID</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="MedShortsLLC"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">GS ID</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="MedShortsLLC"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">ISA qualifier</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="ZZ"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Certificate</label>
            <div class="col-sm-10">
              <a
                href="https://whitelabel-documents-upper-eqhasb1m.s3.us-west-2.amazonaws.com/edi-certs/MedShorts.cer"
                target="_blank"
                class="mr-2"
                >MedShorts (PROD).cer</a
              >
              <a
                href="https://whitelabel-documents-upper-eqhasb1m.s3.us-west-2.amazonaws.com/edi-certs/MedShorts.p7b"
                target="_blank"
                >MedShorts (PROD).p7b</a
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">AS2 Test</h4>
      </div>
      <div class="card-body">
        <form>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Identifier</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="MedShortsLLCT"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">URL</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="http://b2bidev.medshorts.com:4080/exchange/MedShortsLLCT"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Type</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="HTTP"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Encryption</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="TripleDES"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">MDN Receipt</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="Synchronous"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">ISA ID</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="MedShortsLLCT"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">GS ID</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="MedShortsLLCT"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">ISA qualifier</label>
            <div class="col-sm-10">
              <input
                class="form-control"
                placeholder="Email"
                value="ZZ"
                readonly
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Certificate</label>
            <div class="col-sm-10">
              <a
                href="https://whitelabel-documents-upper-eqhasb1m.s3.us-west-2.amazonaws.com/edi-certs/MedShorts+T.cer"
                target="_blank"
                class="mr-2"
                >MedShorts (TEST).cer</a
              >
              <a
                href="https://whitelabel-documents-upper-eqhasb1m.s3.us-west-2.amazonaws.com/edi-certs/MedShorts+T.p7b"
                target="_blank"
                >MedShorts (TEST).p7b</a
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
